import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {HashRouter} from 'react-router-dom';
import { Provider } from 'react-redux'
import store from './redux/store'
// import registerServiceWorker from './registerServiceWorker';
import firebase from 'firebase/app'
import { firebaseConfig } from './firebase/firebaseConfig'

if(!firebase.apps.length)
firebase.initializeApp(firebaseConfig)



ReactDOM.render(
<Provider store={store}>
  <HashRouter>
    <App />
  </HashRouter>
</Provider>
, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js